<script module>
  let count = 0;
</script>

<script>
  import SendAppOverpanel from '../SendAppOverpanel/SendAppOverpanel.svelte';
  import { openOverpanel } from '../../stores/overpanelControl';
  import { KEYCODES } from '../../utils/constants.ts';
  import inputValidator from '../../utils/us-phone-format-validator';
  
  let {
    instructions,
    label,
    inputPlaceholder,
    sendButtonText,
    inputValidationMessage,
    sendAppOverpanel,
    useInAside = false,
    inlineIconsAndText = false,
    dataTestId = 'app-text-promo',
    lang,
    incomingState = 'initial'
  } = $props();

  const key = count++;

  let inputNode = $state();
  let inputValue = $state('');

  // Component State Managment
  const setState = (state) => {
    currentState = { ...initialStates, [state]: true };
  };

  let currentState = $state();

  const initialStates = {
    initial: false,
    populated: false,
    invalid: false,
    pending: false,
    success: false,
  };

  setState(incomingState);

  const reset = () => {
    inputValue = '';
    setState('initial');
  };

  const checkValidity = () => {
    if (!inputNode.validity.valid || !inputValue) {
      setState('invalid');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    openOverpanel('textApp');
  };

  const handleInput = () => {
    const setValue = (value) => (inputNode.value = value);
    if (inputValidator) inputValidator(inputNode.value, setValue);
  };

  const handleBlur = () => {
    if (!inputNode.validity.valid) {
      if (!inputValue) {
        reset();
      } else {
        setState('invalid');
      }
    }
  };

  const handleFocus = () => {
    setState('populated');
  };

  const handleOnKeydown = (e) => {
    if (e.keyCode === KEYCODES.ESCAPE || e.keyCode === KEYCODES.ENTER) return;
    if (currentState.invalid) setState('populated');
  };
</script>

<div
  data-testid={dataTestId}
  class="print:hidden"
  class:max-w-xl={(currentState.initial || currentState.invalid || currentState.pending || currentState.populated) && !useInAside}
  class:p-4={useInAside}
  class:lg:bg-blue-very-light={useInAside}
  class:lg:ml-12={inlineIconsAndText}
  class:lg:grow={inlineIconsAndText}
>
  <div
    class="flex flex-col justify-between"
    class:mt-0={useInAside}
    class:mt-5={inlineIconsAndText}
    class:lg:mt-2={inlineIconsAndText}
    class:mt-8={!useInAside}
    class:items-center={useInAside}
    class:max-w-full={useInAside}
  >
    <p
      class="text-base leading-tight font-medium mb-4 text-blue-navy"
      data-testid="{dataTestId}-instruction-text"
      class:md:text-lg={inlineIconsAndText}
    >
      {instructions}
    </p>
    <form
      id="appTextPromoSubmit-{key}"
      class="flex flex-col sm:flex-row justify-between"
      class:max-w-md={useInAside}
      class:w-full={useInAside}
      class:lg:flex-col={useInAside}
      data-testid="{dataTestId}-form"
      onsubmit={handleSubmit}
    >
      <div class="grow" class:sm:mr-2={!useInAside}>
        <label for="phone-number-{key}" class="visually-hidden">{label}</label>
        <input
          data-testid="{dataTestId}-input"
          id="phone-number-{key}"
          class="rounded border bg-white py-2 px-4 mb-4 w-full leading-loose text-base font-normal placeholder-gray-warm md:inline
            focus:relative focus:outline-none focus:shadow-focus active:shadow-active active:relative"
          class:sm:mb-0={!useInAside}
          class:border-red={currentState.invalid}
          class:text-red={currentState.invalid}
          class:border-gray-gunmetal={currentState.initial || currentState.pending}
          class:text-gray-gunmetal={currentState.initial || currentState.pending}
          type="tel"
          pattern={'[0-9]{3}-[0-9]{3}-[0-9]{4}'}
          placeholder={inputPlaceholder}
          oninput={handleInput}
          onkeydown={handleOnKeydown}
          onfocus={handleFocus}
          onblur={handleBlur}
          bind:this={inputNode}
          bind:value={inputValue}
          required
          aria-required="true" 
        />        
        <div
          class="text-sm text-red leading-normal"
          class:sm:min-h-6={!useInAside}
          class:invisible={currentState.initial || currentState.pending || currentState.populated}
          class:visible={currentState.invalid}
          data-testid="{dataTestId}-validation-message"
        >
          {inputValidationMessage}
        </div>
      </div>
      <button
        class="rounded py-2 px-4 h-12 text-center text-base leading-loose font-medium
          whitespace-nowrap text-white bg-blue-cerulean hover-hover:hover:bg-blue-darkish active:bg-blue-navy
          focus:relative focus:outline-none focus:shadow-focus active:shadow-active active:relative"
        class:sm:ml-3={useInAside}
        class:md:ml-3={!useInAside}
        class:lg:ml-0={useInAside}
        class:px-4={!useInAside}
        class:px-6={useInAside}
        onclick={checkValidity}
        type="submit"
        data-testid="{dataTestId}-submit-button"
      >
        {sendButtonText}
      </button>
    </form>
  </div>
</div>
<SendAppOverpanel closeCallback={reset} {...sendAppOverpanel} destination={inputValue} {lang} />
